import Splide from '@splidejs/splide';

export default function() {
	var splideContainer = document.querySelector('.featured-recipes__splide');
	if (!splideContainer) {
		return;
	}
	var splide = new Splide( '.featured-recipes__splide', {
		arrows: true,
		perPage: 5,
		gap: '1rem',
		padding: '6.875rem',
		focus: 'center',
		type: 'loop',
		breakpoints: {
			1200: {
				perPage: 4,
				padding: '1.666rem',
			},
			968: {
				perPage: 3,
				padding: '5.875rem',
			},
			768: {
				perPage: 2,
				padding: '2rem',
			},
			560: {
				perPage: 1,
				padding: '5.875rem',
			},
			375: {
				perPage: 1,
				padding: '5.875rem',
			}
		}
	} );
	
	splide.mount();
}